module.exports = __webpack_public_path__ + "static/media/impactPain.408bfa55.mp3";